import React, { useState } from "react";
import SubHeader from "../components/subHeader";
import PromoApp from "../components/promoApp";
import SeoTags from "../components/seo";

function Contact(props) {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <SeoTags />
      <main className="container-fluid p-0">
        <div className="container-md mt-5 mb-5">
          <div className="row">
            <div className="col-md">
              <SubHeader
                title={"Kontakt".translate()}
                loading={loading}
                icon={<i className="bi bi-geo-alt icon-primary"></i>}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="row mt-4">
                <div className="col-md">
                  <div className="row">
                    <div className="col-md-3">
                      <img
                        src={
                          process.env.REACT_APP_STATIC_RESOURCES +
                          "just-logo.png"
                        }
                      />
                    </div>
                    <div className="col-md-9 company-title">
                      <div>
                        <h3>{process.env.REACT_APP_NAME.translate()}</h3>
                      </div>
                      <div>{process.env.REACT_APP_PREFIX.translate()}</div>
                      <div>{"Izdavač".translate()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="title mb-1 mt-3">{"Telefon".translate()}</div>
              <div>+381 11 3051 722</div>
              <div className="title mb-1 mt-3">{"E-mail".translate()}</div>
              <div>office@poslovnicentarrakovica.rs</div>
              <div className="title mb-1 mt-3">{"Web".translate()}</div>
              <div>www.poslovnicentarrakovica.rs</div>
            </div>
          </div>
        </div>
        <PromoApp />
      </main>
    </>
  );
}

export default Contact;
